<template>
  <div class="row justify-around items-center q-px-sm statusExtension">
    <span
      v-if="sipConnected"
      class="labelExtension text-center text-blue-gray-9"
    >Ramal {{ extension }}</span>
    <span
      v-else
      class="labelExtension text-center text-blue-gray-9"
    >{{ sipRetrySecs }}</span>

    <ReachableIcon
      v-if="sipConnected"
      class="statusIconXS q-ml-sm"
    />

    <UnReachableIcon
      v-else
      class="statusIconSM text-center reduce-margin-top q-ml-sm"
    />

    <InternetIcon
      v-if="connected"
      class="statusIconXS text-center q-ml-sm"
    />

    <InternetDisconectedIcon
      v-else
      class="statusIconSM text-center reduce-margin-top q-ml-sm"
    />
  </div>
</template>

<script>
import ReachableIcon from '@/assets/icons/reachable.svg'
import UnReachableIcon from '@/assets/icons/unreachable.svg'
import InternetIcon from '@/assets/icons/internet.svg'
import InternetDisconectedIcon from '@/assets/icons/internetDisconected.svg'
import { mapState } from 'vuex'

export default {
  components: {
    ReachableIcon,
    UnReachableIcon,
    InternetIcon,
    InternetDisconectedIcon
  },

  data () {
    return {
      window: {}
    }
  },

  computed: {
    ...mapState({
      connected: (state) => state.connectionModule.connected,
      sipConnected: ({ sipModule }) => sipModule.sipConnected,
      sipRetrySecs: ({ sipModule }) => sipModule.sipRetrySecs ? `Reconexão em ${sipModule.sipRetrySecs}s` : 'SIP offline',
      extension: ({ agentModule }) => agentModule.provision.extension
    })
  }
}
</script>

<style lang="sass" scoped>
.statusExtension
  position: absolute
  bottom: 0
  left: 0
  background: #ddd
  width: 240px
  padding: 4px

.margin-3
  margin: 3px

.title
  font-family: Nunito
  font-style: normal
  font-weight: normal
  font-size: 13px
  line-height: 18px
  color: #263238
  margin-left: 8px

.draggable
  -webkit-app-region: drag

.titleBarBox
  height: 36px
  padding-left: 15px
  z-index: 9999

.reduce-margin-top
  margin-top: -7px

.titleBarBox-PaddingRight
  padding-right: 15px

.borderBottom
  border-bottom: 1px solid #CFD8DC

.icon
  width: 20px
  height: 25px

.statusIconXS
  width: 20px
  height: 16px

.statusIconSM
  width: 27px
  height: 25px

.windowsIcon
  width: 12px
  height: 12px
  cursor: pointer

.macIcon
  width: 12px
  height: 12px
  cursor: pointer

.margin-left-20
  margin-left: 20px

.margin-left-8
  margin-left: 8px

.margin-right-20
  margin-right: 20px

.margin-right-8
  margin-right: 8px

.labelExtension
  font-weight: 300
  font-size: 12px
  line-height: 14px
  color: #263238

.drag
  -webkit-app-region: drag
  -webkit-user-select: none

.hoverEffect
  .macButtonHover
    display: none

.hoverEffect:hover
  .macButton
    display: none

  .macButtonHover
    display: inline
</style>
